
const VARIANTS = {
	'faculty-library': {
		itemsSelector: '[data-library-items]',
		ajaxAction: 'pardes_filter_library',
		localizedKey: 'pardesLibrary',
	},
	'faculty-books': {
		itemsSelector: '[data-books-items]',
		ajaxAction: 'pardes_filter_books',
		localizedKey: 'pardesBooks',
	},
};

class FacultyLoadMore {
	constructor(element, variant) {
		this.element = element;
		this.variant = variant;
		this.itemsContainer = element.querySelector(variant.itemsSelector);
		this.button = element.querySelector('[data-load-more]');
		this.localized = window[variant.localizedKey];

		if (!this.itemsContainer || !this.button || !this.localized?.ajaxUrl) return;

		this.state = {
			facultyId: parseInt(element.dataset.facultyId, 10) || 0,
			perPage: parseInt(element.dataset.perPage, 10) || 9,
			total: parseInt(element.dataset.total, 10) || 0,
			paged: parseInt(element.dataset.paged, 10) || 1,
			loading: false,
		};

		if (!this.state.facultyId) return;

		this.button.addEventListener('click', () => this.loadNextPage());
	}

	async loadNextPage() {
		if (this.state.loading) return;

		const nextPage = this.state.paged + 1;
		this.state.loading = true;
		this.element.classList.add('is-loading');
		this.button.disabled = true;

		const body = new FormData();
		body.append('action', this.variant.ajaxAction);
		body.append('nonce', this.localized.nonce || '');
		body.append('facultyId', this.state.facultyId);
		body.append('postsPerPage', this.state.perPage);
		body.append('paged', nextPage);

		try {
			const response = await fetch(this.localized.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			});
			if (!response.ok) throw new Error(`HTTP ${response.status}`);

			const data = await response.json();
			if (!data?.success || !data.data?.html) return;

			this.appendCards(data.data.html);
			this.state.paged = nextPage;
			this.updateButtonVisibility();
		} catch (err) {
			console.error('Faculty load-more failed:', err);
		} finally {
			this.state.loading = false;
			this.element.classList.remove('is-loading');
			this.button.disabled = false;
		}
	}

	appendCards(html) {
		const grid = this.itemsContainer.querySelector('.library-archive__grid');
		if (!grid) return;

		const parsed = new DOMParser().parseFromString(html, 'text/html');
		parsed.querySelectorAll('.library-card').forEach((card) => {
			grid.appendChild(card);
		});
	}

	updateButtonVisibility() {
		const loaded = this.state.paged * this.state.perPage;
		if (loaded >= this.state.total) {
			this.button.closest('[class$="__action"]')?.remove();
		}
	}

	static init() {
		Object.entries(VARIANTS).forEach(([component, variant]) => {
			document
				.querySelectorAll(`[data-component="${component}"]`)
				.forEach((el) => new FacultyLoadMore(el, variant));
		});
	}
}

export default FacultyLoadMore;
